"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var class_transformer_1 = require("class-transformer");
var PlaybackMeta = /** @class */ (function () {
    function PlaybackMeta() {
    }
    PlaybackMeta.createInstance = function (plainObject) {
        return class_transformer_1.plainToClass(PlaybackMeta, plainObject);
    };
    PlaybackMeta.createInstances = function (plainObjectArray) {
        return class_transformer_1.plainToClass(PlaybackMeta, plainObjectArray);
    };
    return PlaybackMeta;
}());
exports.PlaybackMeta = PlaybackMeta;
//# sourceMappingURL=PlaybackMeta.js.map